﻿import { ConfiguratorDI, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IOutputField } from "@models/entity-models";
import { eOutputFieldType } from "@models/enums";

@Kbo(CToken.OutputField)
export class OutputField extends KbObject implements IOutputField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }
    
    public type: eOutputFieldType;
    public externalId: string;

    /**
     * OBSOLETE - use ConfiguratorDI.getNewOutputField instead
     * This is here for backwards compatibility
     * @param fieldType 
     * @param kom 
     * @param args 
     */
    public static getNewOutputFieldOfType<T extends OutputField>(
        fieldType: eOutputFieldType,
        kom: KbObjectManager,
        args?: IOutputField
    ): T {
        return ConfiguratorDI.getNewOutputField<T>(fieldType, kom, args);
    }
}
